import React from 'react';
import styles from "../../../LocationForm.module.css";
import {ValidationResult} from "../../../../../../../elements/validator/component/ValidationComponent";
import {
    FilePathValidator,
} from "../../../../../../../elements/validator/Validator";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../../../LocationForm";
import {ValidatedInputField} from "../../../../../../../elements/validator/component/ValidatedInputField";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const FileOnSftpFields = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus
  }: Props<T, W>) => {

    return <div className={styles.fieldsLine}>
        <ValidatedInputField<string, T>
            onChange={(v) => updateRequest({filePath: v})}
            updateValidationStatus={updateValidationStatus}
            fieldName={'filePath'}
            selector={selectionProvider.filePath}
            validator={FilePathValidator}
            label={'Full path to file on SFTP'}
            placeholder={"/path/to/file.csv"}
            getMessage={getMessage}
        />
    </div>
}
